var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3030_21070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0605 15.8101C16.1316 15.8101 17.8105 14.1311 17.8105 12.0601C17.8105 9.98899 16.1316 8.31006 14.0605 8.31006C11.9895 8.31006 10.3105 9.98899 10.3105 12.0601C10.3105 14.1311 11.9895 15.8101 14.0605 15.8101Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.94406 16.7559C5.52966 16.0422 5.21218 15.2764 5 14.4788L6.57312 12.51C6.55531 12.209 6.55531 11.9072 6.57312 11.6063L5.00094 9.6375C5.21276 8.83976 5.52959 8.07369 5.94312 7.35938L8.44719 7.07812C8.64715 6.85284 8.86034 6.63965 9.08563 6.43969L9.36688 3.93656C10.0802 3.525 10.845 3.21005 11.6412 3L13.61 4.57312C13.911 4.55531 14.2128 4.55531 14.5137 4.57312L16.4825 3.00094C17.2802 3.21276 18.0463 3.52959 18.7606 3.94312L19.0419 6.44719C19.2672 6.64715 19.4804 6.86034 19.6803 7.08563L22.1834 7.36688C22.5978 8.08065 22.9153 8.84645 23.1275 9.64406L21.5544 11.6128C21.5722 11.9138 21.5722 12.2156 21.5544 12.5166L23.1266 14.4853C22.9162 15.2828 22.601 16.0489 22.1891 16.7634L19.685 17.0447C19.485 17.27 19.2718 17.4832 19.0466 17.6831L18.7653 20.1862C18.0515 20.6006 17.2857 20.9181 16.4881 21.1303L14.5194 19.5572C14.2184 19.575 13.9166 19.575 13.6156 19.5572L11.6469 21.1294C10.8494 20.919 10.0833 20.6038 9.36875 20.1919L9.0875 17.6878C8.86221 17.4879 8.64902 17.2747 8.44906 17.0494L5.94406 16.7559Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3030_21070",
    x: -1.93945,
    y: -1.93994,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3030_21070"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.0980392 0 0 0 0 0.152941 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3030_21070"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3030_21070",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.99648b4f27556418ec9327b221de51e3.svg";
export { ForwardRef as ReactComponent };